
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomumbaicarhire() {



    const cardData =
    {
        keyword: 'Pune Mumbai Car Hire ',
        heading: 'Meghana Cab : Pune Mumbai Car Hire ',
        headingDescription: 'Meghana Cab offers Pune Mumbai Car Hire services, perfect for travelers seeking flexible and comfortable intercity transportation. Whether you are planning a day trip, a business visit, or an extended stay in Mumbai, our wide range of well-maintained vehicles—from economical Hatchbacks and Sedans to premium SUVs and Innova Crystas—ensures a smooth ride. With experienced drivers, on-time pickups, and competitive pricing, we make your Pune to Mumbai travel stress-free and enjoyable. Book your Pune Mumbai Car Hire with Meghana Cab and enjoy door-to-door service, 24/7 customer support, and unmatched reliability.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Car Rental Pune to Mumbai",
        "description": "Enjoy a smooth and hassle-free journey with our Pune to Mumbai car rental service. Whether you're planning a quick business trip, a weekend getaway, or a family outing, we offer well-maintained vehicles with flexible rental options and professional drivers to ensure you travel safely and comfortably."
    },
    {
        "name": "Self Drive or Chauffeur Car Hire Pune Mumbai",
        "description": "Choose between full control or total relaxation with our self-drive and chauffeur-driven car hire from Pune to Mumbai. Whether you're a confident driver seeking privacy or someone who prefers to sit back and relax, we offer flexible plans and a variety of vehicles to suit your travel style."
    },
    {
        "name": "AC Car Hire Pune Mumbai Route",
        "description": "Beat the heat with our air-conditioned car hire service on the Pune to Mumbai route. Our clean, well-ventilated cars ensure a comfortable ride even in peak summer, making your intercity travel relaxing, refreshing, and stress-free."
    },
    {
        "name": "Online Pune to Mumbai Car Hire Booking",
        "description": "Book your Pune to Mumbai car hire online in just a few clicks. Our easy-to-use platform offers real-time availability, instant confirmations, and transparent pricing—no hidden charges, just reliable service and a wide choice of vehicles for every need."
    },
    {
        "name": "Sedan Hire Pune to Mumbai",
        "description": "Travel in elegance with our sedan car hire service from Pune to Mumbai. Ideal for couples, solo travelers, or professionals, our sedans offer a perfect mix of comfort, fuel efficiency, and style for a refined long-distance journey."
    },
    {
        "name": "SUV Car Hire Pune to Mumbai",
        "description": "Hire a spacious SUV for your Pune to Mumbai travel and enjoy ample legroom, luggage capacity, and road grip. Perfect for group outings, family travel, or bumpy routes, our SUVs ensure a sturdy and luxurious ride."
    },
    {
        "name": "Budget Car Hire Pune Mumbai",
        "description": "Looking for an affordable car rental from Pune to Mumbai? Our budget car hire service offers economical yet reliable options for students, small families, and budget-conscious travelers without compromising on safety or cleanliness."
    },
    {
        "name": "Luxury Car Hire Pune to Mumbai",
        "description": "Upgrade your intercity travel with our luxury car rental service from Pune to Mumbai. Choose from top-tier brands with plush interiors, extra legroom, and elite features—perfect for VIP travel, special occasions, or business executives."
    },
    {
        "name": "Business Trip Car Rental Pune to Mumbai",
        "description": "Need a professional ride for your business trip? Our Pune to Mumbai business car rental service offers clean, punctual, and executive-class cars driven by trained chauffeurs—ensuring you're always on time and arrive in style."
    },
    {
        "name": "Private Car Rental Pune to Mumbai",
        "description": "Hire a private car from Pune to Mumbai for a personalized, non-shared experience. Perfect for individuals or families looking for privacy, flexibility, and peace of mind during their intercity journey."
    },
    {
        "name": "Long Drive Car Hire Pune to Mumbai",
        "description": "Planning a scenic drive or leisurely journey from Pune to Mumbai? Our long drive car hire options provide comfort, smooth handling, and excellent mileage—perfect for travelers who love being on the road."
    },
    {
        "name": "Chauffeur Driven Car Hire Pune to Mumbai",
        "description": "Sit back and relax with our chauffeur-driven car hire from Pune to Mumbai. Our courteous, experienced drivers ensure a safe, comfortable, and timely ride, making your travel worry-free and enjoyable."
    },
    {
        "name": "Quick Car Hire Pune Mumbai",
        "description": "Need a car on short notice? Our quick car hire service from Pune to Mumbai offers immediate booking, rapid dispatch, and reliable vehicles to get you moving fast without delays."
    },
    {
        "name": "Pune to Mumbai Hire Car for Family",
        "description": "Traveling with family? Hire our specially selected cars for family trips from Pune to Mumbai—equipped with child locks, extra luggage space, and comfortable seating to ensure a safe and happy journey for all members."
    },
    {
        "name": "Affordable Cab Hire Pune Mumbai",
        "description": "Get great value for money with our affordable cab hire from Pune to Mumbai. Designed for those who want quality service without high costs, our fleet is reliable, well-maintained, and driven by trained professionals."
    }
],
"tableData": [
    ["Car Rental Pune to Mumbai", "Self Drive or Chauffeur Car Hire Pune Mumbai"],
    ["AC Car Hire Pune Mumbai Route", "Online Pune to Mumbai Car Hire Booking"],
    ["Sedan Hire Pune to Mumbai", "SUV Car Hire Pune to Mumbai"],
    ["Budget Car Hire Pune Mumbai", "Luxury Car Hire Pune to Mumbai"],
    ["Business Trip Car Rental Pune to Mumbai", "Private Car Rental Pune to Mumbai"],
    ["Long Drive Car Hire Pune to Mumbai", "Chauffeur Driven Car Hire Pune to Mumbai"],
    ["Quick Car Hire Pune Mumbai", "Pune to Mumbai Hire Car for Family"],
    ["Affordable Cab Hire Pune Mumbai", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Convenient Pune Mumbai Car Hire Services",
        "WhyChoosedescription": "Our Pune to Mumbai car hire service offers the ultimate in convenience and flexibility. Whether you need a car for a business trip, leisure travel, or a family outing, we provide well-equipped vehicles and tailored booking options to suit every travel need."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles to Choose From",
        "WhyChoosedescription": "Choose from a diverse fleet including compact hatchbacks, spacious sedans, SUVs, and luxury cars. Whether you need economy travel or premium comfort, our range of cars meets all budgets and preferences, ensuring you get exactly what you need for the journey."
    },
    {
        "WhyChooseheading": "Chauffeur-Driven or Self-Drive Options",
        "WhyChoosedescription": "We offer both chauffeur-driven and self-drive car hire services between Pune and Mumbai. Opt for a professional driver for a relaxed ride, or enjoy complete control with a self-drive car—perfect for those who prefer privacy and flexibility."
    },
    {
        "WhyChooseheading": "Well-Maintained, Clean, and Safe Vehicles",
        "WhyChoosedescription": "All our cars are regularly serviced, thoroughly cleaned, and undergo strict safety inspections before every hire. From air-conditioning and cushioned seats to working seat belts and sanitized interiors, your safety and comfort are our priority."
    },
    {
        "WhyChooseheading": "Affordable Rates with Transparent Billing",
        "WhyChoosedescription": "We offer competitive pricing with no hidden fees. All car hire packages come with clear, upfront cost breakdowns including fuel, tolls, driver allowance (if applicable), and taxes. Get the best value for your intercity travel budget."
    },
    {
        "WhyChooseheading": "Ideal for Business, Leisure, and Weekend Trips",
        "WhyChoosedescription": "Our Pune to Mumbai car hire service is perfect for business professionals attending meetings, families on vacation, or individuals planning quick weekend getaways. Travel comfortably and on your own schedule, without depending on trains or buses."
    },
    {
        "WhyChooseheading": "Doorstep Delivery and Pickup Available",
        "WhyChoosedescription": "We provide doorstep vehicle delivery in Pune and convenient drop-off options in Mumbai, saving you time and effort. Whether you’re at home, the office, or a hotel, our service adapts to your preferred pickup and return locations."
    },
    {
        "WhyChooseheading": "24/7 Booking and On-Road Assistance",
        "WhyChoosedescription": "Book anytime with our 24/7 support system. We also offer round-the-clock on-road assistance for breakdowns or emergencies, giving you peace of mind throughout your journey. Our team is just a call away, ready to assist whenever needed."
    }
]

















    }

const faqData = [
    {
        question: "How can I hire a car from Pune to Mumbai with Meghana Cab?",
        answer: "You can hire a car easily by calling us at +91 9075462128 or booking through our website for instant confirmation."
    },
    {
        question: "What types of cars are available for hire between Pune and Mumbai?",
        answer: "We offer hatchbacks, sedans, SUVs, and tempo travellers to suit individual, family, or group travel needs."
    },
    {
        question: "Is car hire available for both one way and round trip?",
        answer: "Yes, you can choose between one way and round trip options as per your travel plan."
    },
    {
        question: "Are the drivers familiar with the Pune-Mumbai route?",
        answer: "Yes, our drivers are well-trained and experienced with the Pune to Mumbai route for safe and efficient travel."
    },
    {
        question: "What’s included in the Pune-Mumbai car hire charges?",
        answer: "Our charges include fuel, tolls, and driver fees. Any additional stops, waiting, or parking charges are extra."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ajay Thakur',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Hired a car from Pune to Mumbai with Meghana Cab—smooth ride, courteous driver, and no hidden costs. Highly recommend!”',
    },
    {
        name: 'Mrs. Priya Nair',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Reliable car hire service between Pune and Mumbai. Clean vehicle and on-time pickup every time.”',
    },
];
















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Mumbai Car Hire",
  "image": "https://www.meghanacabs.com/assets/images/pune-mumbai-car-hire.jpg",
  "description": "Hire a car from Pune to Mumbai with Meghana Cabs. Choose from AC Sedans, SUVs, and luxury vehicles with self-drive or chauffeur-driven options. Ideal for family trips, business travel, and long drives. Book online 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1899",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-mumbai-car-hire"
  }
};







    return (
        <div>
<Helmet>
  <title>Pune Mumbai Car Hire | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Hire a car from Pune to Mumbai with Meghana Cabs. Choose from AC Sedans, SUVs, or luxury cars. Chauffeur and self-drive options available. Perfect for business or family travel. Book online 24/7." 
  />
  <meta 
    name="keywords" 
    content="Car Rental Pune to Mumbai, Self Drive or Chauffeur Car Hire Pune Mumbai, AC Car Hire Pune Mumbai Route, Online Pune to Mumbai Car Hire Booking, Sedan Hire Pune to Mumbai, SUV Car Hire Pune to Mumbai, Budget Car Hire Pune Mumbai, Luxury Car Hire Pune to Mumbai, Business Trip Car Rental Pune to Mumbai, Private Car Rental Pune to Mumbai, Long Drive Car Hire Pune to Mumbai, Chauffeur Driven Car Hire Pune to Mumbai, Quick Car Hire Pune Mumbai, Pune to Mumbai Hire Car for Family, Affordable Cab Hire Pune Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/78.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaicarhire;